import * as _ from 'lodash';
import Validator from 'validatorjs';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import EntidadRules from '../../../support/rules/ine/EntidadRules';
import AmbitoOptions from '../../../support/catalogs/complementos/ine/AmbitoOptions';
import ClaveEntidadOptions from '../../../support/catalogs/complementos/ine/ClaveEntidadOptions';

const EntidadForm = (props) => {

  const [data, setData] = useState({});
  const [visible, setVisible] = useState({});
  const [validation, setValidation] = useState({
    validator: new Validator({}, EntidadRules()),
    isValid: false,
  });

  const { isValid } = validation;
  const { data: editing, ruleData } = props;
  const rules = EntidadRules(data, ruleData);
  let ClaveEntidadItems = ClaveEntidadOptions(data.Ambito, ruleData);

  const handleOnChange = (event) => {
    const newData = {
        ...data,
        ...event,
    }

    setData(newData);
  }

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidation = {
      validator: validator,
      isValid: validator.passes()
    };

    setValidation(newValidation);
  }

  useEffect(() => {
    validate(data);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!editing && !!editing.id) {
      setData({
        ...data,
        ...editing,
      });
    }
  }, [editing]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnAdd = () => {
    props.onAdd(data);

    clear();
  }

  const clear = () => {
    setData({});
  };

  useEffect(() => {
    if (ruleData.TipoComite === '') {
      setVisible({
        ...visible,
        Ambito: visible.Ambito = true,
      });
    }

    if (ruleData.TipoComite === 'Ejecutivo Estatal') {
      setVisible({
        ...visible,
        Ambito: visible.Ambito = false,
      });
    }

    if (ruleData.TipoComite === 'Directivo Estatal') {
      setVisible({
        ...visible,
        Ambito: visible.Ambito = false,
      });
    }

    if (_.isEqual(ruleData.TipoProceso, 'Campaña') || _.isEqual(ruleData.TipoProceso, 'Precampaña')) {
      setVisible({
        ...visible,
        Ambito: visible.Ambito = true,
      });
    }
  }, [ruleData]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <h5 className="text-right">Entidad</h5>

      <Row>
        <Col sm md={ 6 }>
          <FormControl
            type="select"
            label="Ambito"
            name="Ambito"
            placeholder=""
            help=""
            disabled={ !visible.Ambito }
            rules={ rules.Ambito }
            value={ data.Ambito }
            options={ AmbitoOptions }
            onChange={ handleOnChange }
          />
        </Col>
        <Col sm md={ 6 }>
          <FormControl
            type="select"
            label="Disposición fiscal"
            name="ClaveEntidad"
            placeholder=""
            help=""
            rules={ rules.ClaveEntidad }
            value={ data.ClaveEntidad }
            options={ ClaveEntidadItems }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>

      <Row>
        <Col className="text-right pb-2">
          <Button
            variant="secondary"
            disabled={ !isValid }
            onClick={ handleOnAdd }
          >
            Agregar Entidad
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default EntidadForm;
